module.exports = __webpack_public_path__ + "static/3dgence-printer-double-96db64df8f2a08e3df3a627669a5244a.png";